/**
 * The row counts an offset-paginated table offers.
 *
 * Shared rather than owned by the pager component, because the size is now part of the screen's
 * URL (`?limit=100`) as well as its chrome: the reader that validates the param and the select
 * that sets it have to agree, and one list of sizes is how they cannot drift.
 */

/** The page sizes offered. The largest matches the contract's `limit` ceiling. */
export const PAGE_SIZES = [25, 50, 100, 200] as const;
